export default __webpack_public_path__ + "static/media/blurBlob.93ff632e.png";